
import Vue from 'vue'
import _ from 'lodash'
import { DEFAULT_PAGE_SIZE } from '@/config/app'
import { i18n } from '@/i18n'

const getDefaultState = () => {
  return {
    paginationInfo: {
      total: 0,
      currentPage: 1,
      totalPages: 0,
      pageSize: DEFAULT_PAGE_SIZE
    },
    currentPage: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: null,
    order: null,
    filters: [],
    notificationsNumber: {},
    menuType: null,
    masterFilters: {
      fechaDisposicionDesde: { label: 'F. disposición desde', value: '' },
      fechaDisposicionHasta: { label: 'F. disposición hasta', value: '' },
      fechaDescargaDesde: { label: 'F. descarga desde', value: '' },
      fechaDescargaHasta: { label: 'F. descarga hasta', value: '' },
      fechaFinTramiteDesde: { label: 'F. fin trámite desde', value: '' },
      fechaFinTramiteHasta: { label: 'F. fin trámite hasta', value: '' },
      tipoNotif: { label: 'Tipo', value: '' },
      codPGN: { label: 'Sede', value: '' },
      estadoDescarga: { label: 'Estado', value: '' },
      estadoDescargaExtra: { label: 'Estado', value: '' },
      asunto: { label: 'Asunto', value: '' },
      idInterno: { label: 'Id Int', value: '' },
      full_text: { label: 'Contenido adjunto', value: '' },
      ultimoError: { label: 'Error temporal', value: '' },
      ticketId: { label: 'TicketId', value: '' },
      cif: { label: i18n.t('app.cif'), value: '' },
      cifTitular: { label: 'CIF Titular', value: '' },
      NombreCIF: { label: 'Razón social', value: '' },
      organismo: { label: 'Organismo', value: '' },
      empresa: { label: i18n.t('app.client'), value: '' },
      notas: { label: i18n.t('notificationFilter.notas'), value: '' },
    },
    notUseLikeTags: ['results', 'page', 'sort', 'order', 'estadoDescarga', 'idPGN'],
    kendo: {
      columns: [
        {
          field: 'selected',
          width: '50px',
          minResizableWidth: 50,
          headerSelectionValue: false,
          locked: true,
          lockable: false,
          columnMenu: false,
          reorderable: false,
          groupable: false
        },
        {
          field: 'Tipo.Tipo',
          title: i18n.t('app.type'),
          columnMenu: 'myTemplate',
          locked: false,
          width: '180px',
          minResizableWidth: 130
        },
        {
          field: 'TicketID',
          title: i18n.t('app.TicketID'),
          columnMenu: 'myTemplate',
          locked: false,
          width: '240px',
          minResizableWidth: 180
        },
        {
          field: 'Distribuidor',
          title: i18n.t('distributors.distributor'),
          columnMenu: 'myTemplate',
          hidden: true,
          locked: false,
          width: '180px',
          minResizableWidth: 130
        },
        {
          field: 'Empresa.Empresa',
          title: i18n.t('app.client'),
          columnMenu: 'myTemplate',
          hidden: true,
          locked: false,
          width: '180px',
          minResizableWidth: 130
        },
        {
          field: 'Organismo',
          title: i18n.t('app.organismo'),
          columnMenu: 'myTemplate',
          locked: false,
          width: '180px',
          minResizableWidth: 90,
          minGridWidth: 600
        },
        {
          field: 'Sede.Sede',
          title: i18n.t('app.location'),
          columnMenu: 'myTemplate',
          locked: false,
          width: '180px',
          minResizableWidth: 130
        },
        {
          field: 'Estado.Estado',
          title: i18n.t('app.status'),
          columnMenu: 'myTemplate',
          locked: false,
          width: '180px',
          minResizableWidth: 130
        },
        {
          field: 'DescargadaAutomaticamente',
          title: i18n.t('notificationFilter.descargada_automaticamente'),
          columnMenu: 'myTemplate',
          locked: false,
          width: '275px',
          minResizableWidth: 206,
          cell: 'checkboxTemplate',
          hidden: true,
        },
        {
          field: 'FechaDisposicion',
          title: i18n.t('notificationFilter.disposition_date'),
          type: 'date',
          filter: 'date',
          format: '{0:dd-MM-yyyy HH:mm}',
          columnMenu: 'myTemplate',
          locked: false,
          width: '220px',
          minResizableWidth: 165
        },
        {
          field: 'FechaDescarga',
          title: i18n.t('app.date_download'),
          type: 'date',
          filter: 'date',
          format: '{0:dd-MM-yyyy HH:mm}',
          columnMenu: 'myTemplate',
          cell: 'fechaTemplate',
          locked: false,
          width: '220px',
          minResizableWidth: 165
        },
        {
          field: 'FechaFinTramite',
          title: i18n.t('app.date_end'),
          type: 'date',
          filter: 'date',
          format: '{0:dd-MM-yyyy HH:mm}',
          columnMenu: 'myTemplate',
          cell: 'fechaTemplate',
          locked: false,
          width: '220px',
          minResizableWidth: 165
        },
        {
          field: 'FechaRegistro',
          title: i18n.t('app.date_register'),
          type: 'date',
          filter: 'date',
          format: '{0:dd-MM-yyyy HH:mm}',
          columnMenu: 'myTemplate',
          cell: 'fechaTemplate',
          locked: false,
          width: '220px',
          minResizableWidth: 165,
          hidden: true,
        },
        {
          field: 'Asunto',
          title: i18n.t('app.subject'),
          columnMenu: 'myTemplate',
          locked: false,
          width: '250px',
          minResizableWidth: 187,
          minGridWidth: 600
        },
        {
          field: 'CIFTitular',
          title: i18n.t('app.CIFTitular'),
          columnMenu: 'myTemplate',
          locked: false,
          width: '220px',
          minResizableWidth: 165,
          minWidth: 200
        },
        {
          field: 'NombreCIF',
          title: i18n.t('app.nombre_cif'),
          columnMenu: 'myTemplate',
          locked: false,
          width: '220px',
          minResizableWidth: 165,
          minWidth: 200
        },
        {
          field: 'CIF',
          title: i18n.t('app.cif'),
          columnMenu: 'myTemplate',
          locked: false,
          hidden: true,
          width: '220px',
          minResizableWidth: 165,
          minWidth: 200
        },
        {
          field: 'Grupos',
          width: '440px',
          minResizableWidth: 220,
          title: i18n.t('app.groups'),
          columnMenu: 'myTemplate',
          locked: false,
          cell: 'groupsTemplate',
          type: 'boolean',
          sortable: false,
          groupable: false,
        },
        {
          field: 'UsuarioResponsable',
          title: i18n.t('app.user_responsable'),
          columnMenu: 'myTemplate',
          locked: false,
          hidden: true,
          width: '300px',
          minResizableWidth: 200,
        },
        {
          field: 'UltimoError',
          title: i18n.t('app.last_error'),
          columnMenu: 'myTemplate',
          locked: false,
          width: '220px',
          minResizableWidth: 165,
          minWidth: 200,
          hidden: true
        },
        { 
          field: 'EnviarEmailError', 
          width: '200px', 
          minResizableWidth: 100,
          title: i18n.t('notificationFilter.eviar_email_error'), 
          columnMenu: 'myTemplate',
          cell: 'checkboxTemplate',
          locked: false,
          hidden: true, 
        },
        { 
          field: 'TieneDestinatarioAutomatico', 
          width: '250px', 
          minResizableWidth: 125,
          title: i18n.t('notificationFilter.tieneDestinatarioAutomatico'), 
          columnMenu: 'myTemplate',
          cell: 'checkboxTemplate',
          locked: false,
          hidden: true, 
        },
        { 
          field: 'TieneReglaAplicada', 
          width: '200px', 
          minResizableWidth: 100,
          title: i18n.t('notificationFilter.tieneReglaAplicada'), 
          columnMenu: 'myTemplate',
          cell: 'checkboxTemplate',
          locked: false,
          hidden: true, 
        },
        {
          field: 'UltimaReglaAplicada',
          title: i18n.t('notificationFilter.UltimaReglaAplicada'),
          columnMenu: 'myTemplate',
          locked: false,
          width: '220px',
          minResizableWidth: 165,
          hidden: true
        },
        { 
          field: 'ReincidenciaErrores', 
          width: '200px', 
          minResizableWidth: 100,
          title: i18n.t('notificationFilter.ReincidenciaErrores'), 
          columnMenu: 'myTemplate',
          cell: 'checkboxTemplate',
          locked: false,
          hidden: true, 
        },
        {
          field: 'ListaTo',
          title: i18n.t('app.list_emails_to'),
          columnMenu: 'myTemplate',
          locked: false,
          width: '250px',
          minResizableWidth: 187,
          hidden: true,
          sortable: false,
          groupable: false,
        },
        {
          field: 'ListaCC',
          title: i18n.t('app.list_emails_cc'),
          columnMenu: 'myTemplate',
          locked: false,
          width: '250px',
          minResizableWidth: 187,
          hidden: true,
          sortable: false,
          groupable: false,
        },
        {
          field: 'ListaCCO',
          title: i18n.t('app.list_emails_cco'),
          columnMenu: 'myTemplate',
          locked: false,
          width: '300px',
          minResizableWidth: 225,
          hidden: true,
          sortable: false,
          groupable: false,
        },
        {
          field: 'IDInterno',
          title: i18n.t('app.ID'),
          hidden: true,
          columnMenu: 'myTemplate',
          locked: false,
          width: '120px',
          minResizableWidth: 50
        },
        { 
          field: 'Empresa.Id', 
          title: i18n.t('companies.id_client'), 
          hidden: true, 
          columnMenu: 'myTemplate', 
          width: '150px', 
          minResizableWidth: 100,
          locked: false 
        },
        // Sugerencias IA
        {
          field: 'EstadoSugerencia',
          title: i18n.t('app.status_suggested'),
          columnMenu: 'myTemplate',
          locked: false,
          width: '250px',
          minResizableWidth: 150,
          hidden: true,
        },
        {
          field: 'GrupoSugerido',
          width: '300px',
          minResizableWidth: 120,
          title: i18n.t('app.groups_suggested'),
          columnMenu: 'myTemplate',
          locked: false,
          cell: 'groupsTemplate',
          type: 'boolean',
          sortable: false,
          groupable: false,
          hidden: true,
        },
        {
          field: 'FechaFinTramiteSugerida',
          title: i18n.t('app.date_end_suggested'),
          type: 'date',
          filter: 'date',
          format: '{0:dd-MM-yyyy HH:mm}',
          columnMenu: 'myTemplate',
          cell: 'fechaTemplate',
          locked: false,
          width: '350px',
          minResizableWidth: 160,
          hidden: true,
        },
        // Metadatos adicionales
        { 
          field: 'Metadato1', 
          title: 'Metadato 1', 
          columnMenu: 'myTemplate', 
          width: '400px', 
          minResizableWidth: 200,
          hidden: true, 
          locked: false,
          sortable: false,
          groupable: false,
        },
        { 
          field: 'Metadato2', 
          title: 'Metadato 2', 
          columnMenu: 'myTemplate', 
          width: '400px', 
          minResizableWidth: 200,
          hidden: true, 
          locked: false,
          sortable: false,
          groupable: false,
        },
        { 
          field: 'Metadato3', 
          title: 'Metadato 3', 
          columnMenu: 'myTemplate', 
          width: '400px', 
          minResizableWidth: 200,
          hidden: true, 
          locked: false,
          sortable: false,
          groupable: false,
        },
        { 
          field: 'Metadato4', 
          title: 'Metadato 4', 
          columnMenu: 'myTemplate', 
          width: '400px', 
          minResizableWidth: 200,
          hidden: true, 
          locked: false,
          sortable: false,
          groupable: false,
        },
        { 
          field: 'Metadato5', 
          title: 'Metadato 5', 
          columnMenu: 'myTemplate', 
          width: '400px', 
          minResizableWidth: 200,
          hidden: true, 
          locked: false,
          sortable: false,
          groupable: false,
        },
      ],
      skip: 0,
      take: 10,
      sortable: { mode: 'multiple' },
      sort: [],
      groupable: true,
      reorderable: true,
      group: [],
      filter: null,
      columnMenu: true,
      dataResult: null,
      navigate: true
    }
  }
}

const state = getDefaultState()

const getters = {
  getPayloadCurrentPage: state => state.paginationInfo.currentPage,
  getPayloadPageSize: state => state.paginationInfo.pageSize,
  getPayloadTotal: state => state.paginationInfo.total,
  getPayLoadTotalPages: state => state.paginationInfo.totalPages,
  getMasterFilters: state => state.masterFilters,
  getCurrentPage: state => state.currentPage,
  getPageSize: state => state.pageSize,
  getKendo: state => state.kendo,
  getNotificationsNumber: state => state.notificationsNumber,
  getMenuType: state => parseInt(state.menuType),
  getPaginationInfo: state => {
    state.paginationInfo.pageSize = state.pageSize
    return state.paginationInfo
  },
  getFilters: (state) => {
    state.filters.results = state.pageSize
    state.filters.page = state.currentPage
    if (state.order) {
      state.filters.order = state.order
    } else {
      delete (state.filters.order)
    }
    if (state.sort && state.filters.order) {
      state.filters.sort = state.sort
    } else {
      delete (state.filters.sort)
    }
    return state.filters
  },
  getTags: (state) => {
    const tags = []
    _.each(state.filters, (item, key) => {
      if (state.notUseLikeTags.indexOf(key) === -1) {
        tags.push([key, item.label, item.value])
      }
    })
    return tags
  },
  getAppliedFilters (state) {
    const data = {}
    const _temp = Object.entries(state.masterFilters)
    _.each(_temp, (item) => {
      if (item[1].value !== '') data[item[0]] = item[1]
    })
    state.filters = data
    return data
  }
}

const mutations = {
  showHideColumn (state, data) {
    // const data = { columnField: 'name', hidden: true/false }
    state.kendo.columns = state.kendo.columns.map(x => {
      if (x.field === data?.columnField) x.hidden = data?.hidden
      return x
    })
  },
  setkendoColumnsMetadatos (state, data) {
    const titleBase = 'Metadato adicional: '
    state.kendo.columns = state.kendo.columns.map(x => {
      if (x.field === 'Metadato1') x.title = data.metadato1 ? titleBase + data.metadato1 : 'No definido'
      if (x.field === 'Metadato2') x.title = data.metadato2 ? titleBase + data.metadato2 : 'No definido'
      if (x.field === 'Metadato3') x.title = data.metadato3 ? titleBase + data.metadato3 : 'No definido'
      if (x.field === 'Metadato4') x.title = data.metadato4 ? titleBase + data.metadato4 : 'No definido'
      if (x.field === 'Metadato5') x.title = data.metadato5 ? titleBase + data.metadato5 : 'No definido'
      return x
    })
  },
  setKendoColumns (state, data) {
    data.unshift('selected')
    state.kendo.columns = state.kendo.columns.map(x => {
      if (data.includes(x.field)) {
        x.hidden = false
      } else {
        x.hidden = true
        data.push(x.field)
      }
      return x
    }).sort((a, b) => data.indexOf(a.field) - data.indexOf(b.field))
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  resetStateWithoutSort (state, data) {
    Object.assign(state, getDefaultState())
    // Object.assign(state, getDefaultState())
    state.kendo.sort = data.sort
    state.kendo.group = data.group
  },
  resetPaginationInfo (state, data) {
    state.pageSize = DEFAULT_PAGE_SIZE
    state.paginationInfo = {
      total: 0,
      currentPage: 1,
      totalPages: 0,
      pageSize: DEFAULT_PAGE_SIZE
    }
  },
  setPaginationInfo (state, data) {
    state.paginationInfo = data
  },
  setSort (state, fieldName) {
    state.sort = fieldName
  },
  setKendo (state, kendo) {
    state.kendo = kendo
  },
  setSortOrder (state, order) {
    switch (order) {
      case 'ascending':
        state.order = 'asc'
        break
      case 'descending':
        state.order = 'desc'
        break
      default:
        state.order = null
        state.sort = null
    }
  },
  setNotUseLikeTags (state, items = []) {
    state.notUseLikeTags = items
  },
  setMasterFilters (state, master) {
    const data = {}
    const _temp = Object.entries(master)
    _.each(_temp, (item) => {
      // Modificado para objetos multiples con valor obligatario
      if (item[1].value !== '' && item[1].value?.valor !== '') data[item[0]] = item[1]
    })
    state.masterFilters = data
    // console.log(data)
  },
  setNotificationsNumber (state, notificationsNumber) {
    state.notificationsNumber = notificationsNumber
  },
  setMenuType (state, menuType) {
    state.menuType = menuType
  },
  resetNotificationsNumber () {
    state.notificationsNumber = {}
  },
  removeTag (state, tag) {
    const path = tag.split('.')
    if (path.length === 1) {
      state.masterFilters[path[0]] = ''
    }
    if (path.length === 2) {
      state.masterFilters[path[0]][path[1]] = ''
    }
  },
  resetMasterFilters (state) {
    state.masterFilters = {
      fechaDisposicionDesde: { label: 'F. disposición desde', value: '' },
      fechaDisposicionHasta: { label: 'F. disposición hasta', value: '' },
      fechaDescargaDesde: { label: 'F. descarga desde', value: '' },
      fechaDescargaHasta: { label: 'F. descarga hasta', value: '' },
      fechaFinTramiteDesde: { label: 'F. fin trámite desde', value: '' },
      fechaFinTramiteHasta: { label: 'F. fin trámite hasta', value: '' },
      tipoNotif: { label: 'Tipo', value: '' },
      codPGN: { label: 'Sede', value: '' },
      estadoDescarga: { label: 'Estado', value: '' },
      estadoDescargaExtra: { label: 'Estado', value: '' },
      asunto: { label: 'Asunto', value: '' },
      idInterno: { label: 'Id Int', value: '' },
      full_text: { label: 'Contenido adjunto', value: '' },
      ultimoError: { label: 'Error temporal', value: '' },
      ticketId: { label: 'TicketId', value: '' },
      cif: { label: i18n.t('app.cif'), value: '' },
      cifTitular: { label: 'CIF Titular', value: '' },
      NombreCIF: { label: 'Razón social', value: '' },
      organismo: { label: 'Organismo', value: '' },
      empresa: { label: i18n.t('app.client'), value: '' },
      notas: { label: i18n.t('notificationFilter.notas'), value: '' },
    }
    state.filters = []
  },
  setFilter (state, { key, value }) {
    Vue.set(state.filters, { key: value })
  },
  setFilters (state, thefilters) {
    Vue.set(state, 'filters', thefilters)
  },
  clearFilters (state) {
    Vue.set(state, 'filters', [])
  },
  clearPagination (state) {
    state.pageSize = DEFAULT_PAGE_SIZE
    state.currentPage = 1
  },
  setPageSize (state, size) {
    state.pageSize = size
  },
  setCurrentPage (state, pageNumner) {
    if (pageNumner > 0 && pageNumner <= state.paginationInfo.totalPages) {
      state.currentPage = pageNumner
      state.paginationInfo.currentPage = pageNumner
    }
  },
  resetColumnOrderDefault (state) {
    // Eliminamos la ordenación y agrupación para columnas excepcionales
    state.kendo.sort = state.kendo.sort.filter(x => x.field !== 'UltimoError')
    state.kendo.group = state.kendo.group.filter(x => x.field !== 'UltimoError')
    if (state.filters.ultimoError !== undefined) delete state.filters.ultimoError
  }
}

const actions = {
  resetCartState ({ commit }) {
    commit('resetState')
  },
  resetStateWithoutSort ({ commit, rootGetters }) {
    const data = {
      sort: rootGetters['notificationsPersisted/getSort'],
      group: rootGetters['notificationsPersisted/getGroup'],
    }
    commit('resetStateWithoutSort', data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
